
import { getAccountsCountByType } from "../../service/api/accountService";
import { useChartLoading } from "../../service/Hooks/useChartLoading";
import useSelectedDomain from "../../service/Hooks/useSelectedDomain";
import ChartSkeleton from "../../skeleton/ChartSkeleton";
import DonutChart from "../DonutChart/DonutChart";

export const ChartRepartitionClients = ({ selectedYear = null }) => {
  const selectedDomain = useSelectedDomain();
  
  const { loading } = useChartLoading(
    () => getAccountsCountByType(selectedDomain?.id, selectedYear),
    [selectedDomain?.id, selectedYear]
  );

  if (loading) {
    return <ChartSkeleton delay="0.1s" />;
  }
  
  return (
    <DonutChart
      title="Répartition des clients"
      subtitle="Par catégorie principale"
      fetchData={() => getAccountsCountByType(selectedDomain.id, selectedYear)}
      valueKey="count"
      formatValue={(v) => v.toLocaleString('fr-FR')}
      centerLabel="Clients"
      selectedYear={selectedYear}
      delay="0.1s"
    />
  );
};